// noinspection CssUnknownTarget

export { GridType, Effect, Orientation, Mockup, createPhotoProduct, PhotoProductViewModel, drawSpecialGrid9X13Plus4TimesMini, drawSpecialGrid9X13Plus2Times6X9 };

function applyEffect(effect) {
  if (effect === Effect.Sepia) {
    return "filter: sepia(100%);";
  } else if (effect === Effect.BlackWhite) {
    return "filter: grayscale(100%);";
  } else {
    return "filter: none;";
  }
}
function createGridMockup(imageUrl, gridType, orientation, effect) {
  function getClassByOrientation(orientation) {
    if (orientation === Orientation.Landscape) {
      return "grid-landscape";
    } else if (orientation === Orientation.Portrait) {
      return "grid-portrait";
    } else {
      return "";
    }
  }

  let html = "";
  let resizeFunction = () => {};
  const styleEffect = applyEffect(effect);
  const backgroundImageStyle = `background-image: url('${imageUrl}');`;

  switch (gridType) {
    case GridType.Normal1X1: {
      // Grid Normal 1x1 (single image)
      html += `
            <div class="product-grid ${getClassByOrientation(orientation)}" style="${styleEffect}" photo-grid>
                <div class="product-grid-image" style="background-position: center; ${backgroundImageStyle}"></div>
            </div>`;
      break;
    }

    case GridType.Normal1X2: {
      if (orientation === "Portrait") {
        // Grid Normal 1x2 (2 columns in portrait)
        html += `
                <div class="product-grid grid-1x2-portrait" style="grid-template-columns: repeat(2, 1fr); grid-template-rows: 1fr; ${styleEffect}" photo-grid>
                    <div class="product-grid-image" style="grid-area: 1 / 1 / 2 / 2; ${backgroundImageStyle};"></div>
                    <div class="product-grid-image" style="grid-area: 1 / 2 / 2 / 3; ${backgroundImageStyle};"></div>
                </div>`;
      } else {
        // Grid Normal 1x2 (2 rows in landscape)
        html += `
                <div class="product-grid grid-1x2-landscape" style="${styleEffect}" photo-grid>
                    <div class="product-grid-image" style="grid-area: 1 / 1; ${backgroundImageStyle};"></div>
                    <div class="product-grid-image" style="grid-area: 2 / 1; ${backgroundImageStyle};"></div>
                </div>`;
      }
      break;
    }
    case GridType.Normal2X2: {
      // Grid Normal 2x2 (four images with different positions)
      html += `
                <div class="product-grid ${orientation === Orientation.Landscape ? "grid-2x2-landscape" : "grid-2x2-portrait"}" style="${styleEffect}" photo-grid>
                    <div class="product-grid-image" style="grid-area: 1 / 1 / 2 / 2; ${backgroundImageStyle}; background-position: right;"></div>
                    <div class="product-grid-image" style="grid-area: 1 / 2 / 2 / 3; ${backgroundImageStyle}; background-position: left;"></div>
                    <div class="product-grid-image" style="grid-area: 2 / 1 / 3 / 2; ${backgroundImageStyle}; background-position: right;"></div>
                    <div class="product-grid-image" style="grid-area: 2 / 2 / 3 / 3; ${backgroundImageStyle}; background-position: left;"></div>
                </div>`;
      break;
    }
    case GridType.Normal4X2:{
      // Grid Normal 4x2: rows/columns depend on orientation
      const rowsCount = orientation === Orientation.Portrait ? 2 : 4;
      const colsCount = orientation === Orientation.Portrait ? 4 : 2;
      const className = orientation === Orientation.Landscape ? "grid-4x2-portrait" : "grid-4x2-landscape";
      html += `<div class="product-grid ${className}" style="grid-template-columns: repeat(${colsCount}, 1fr); grid-template-rows: repeat(${rowsCount}, 1fr); ${styleEffect}" photo-grid>`;
      for (let row = 1; row <= rowsCount; row++) {
        for (let col = 1; col <= colsCount; col++) {
          const side = col === 1 ? "right" : "left";
          html += `
                    <div class="product-grid-image" style="grid-area: ${row} / ${col} / ${row + 1} / ${col + 1}; ${backgroundImageStyle}; background-position: ${side}"></div>
            `;
        }
      }
      html += `</div>`;
      break;
    }

    case GridType.Normal4X4: {
      // Grid Normal 4x4 (16 images)
      html += `<div class="product-grid ${getClassByOrientation(orientation)}" style="grid-template-columns: repeat(4, 1fr); grid-template-rows: repeat(4, 1fr); ${styleEffect}" photo-grid>`;
      for (let row = 1; row <= 4; row++) {
        for (let col = 1; col <= 4; col++) {
          html += `
                    <div class="product-grid-image" style="grid-area: ${row} / ${col} / ${row + 1} / ${col + 1}; ${backgroundImageStyle}; background-position: center;"></div>
            `;
        }
      }
      html += `</div>`;
      break;
    }
    case GridType.Special9X13Plus2Times6X9: {
      const id = `photo-product-${Math.random().toString(36).substring(7)}`;
      html = `
            <div class="product-grid special-grid-container">
                <canvas id="${id}" width="1000" height="1000" class="grid-landscape"></canvas>
            </div>
        `;
      resizeFunction = () => drawSpecialGrid9X13Plus2Times6X9(orientation, id, imageUrl, effect);
      break;
    }
    case GridType.Special9X13Plus4TimesMini:{
      const id = `photo-product-${Math.random().toString(36).substring(7)}`;
      html = `
                <div class="product-grid special-grid-container">
                    <canvas id="${id}" width="1000" height="1000" class="grid-landscape"></canvas>
                </div>
        `;
      resizeFunction = () => drawSpecialGrid9X13Plus4TimesMini(orientation, id, imageUrl, effect);
      break;
    }
    default:{
      console.error("Unknown grid type", gridType);
      break;
    }
  }

  return new PhotoProductNode(html, resizeFunction);
}
function createMugPhotoProduct(photoProductViewModel) {
  const className = photoProductViewModel.orientation === Orientation.Landscape ? 'image-landscape' : 'image-portrait';
  const id = `photo-product-${Math.random().toString(36).substring(7)}`;
  const style = applyEffect(photoProductViewModel.effect);
  const resizeFunction = getResizeFunction(id, Orientation.Portrait);
  const html = `
      <div class="mug-mockup-container" id="${id}">
          <img class="background-photo" src="/mug_thumb.png" alt="Mug"/>
          <div class="mug-overlay">
              <img class="${className}" style="${style}" src="${photoProductViewModel.imageUrl}" alt="Photo"/>
          </div>
      </div>
  `;
  return new PhotoProductNode(html, resizeFunction);
}

function createPillowPhotoProduct(photoProductViewModel) {
  const className = photoProductViewModel.orientation === Orientation.Landscape ? 'image-landscape' : 'image-portrait';
  const id = `photo-product-${Math.random().toString(36).substring(7)}`;
  const style = applyEffect(photoProductViewModel.effect);
  const resizeScript = getResizeFunction(id, Orientation.Portrait);
  const html = `
      <div class="pillow-mockup-container" id="${id}">
          <img class="background-photo" src="/pillow_thumb.png" alt="Pillow"/>
          <div class="pillow-overlay">
              <img class="${className}" style="${style}" src="${photoProductViewModel.imageUrl}" alt="Photo"/>
          </div>
      </div>
  `;
  return new PhotoProductNode(html, resizeScript);
}

function getResizeFunction(id, backgroundOrientation) {
  return () => {
    const container = $(`#${id}`);
    const parent = container.parent();
    if (parent.width() > parent.height() && backgroundOrientation === Orientation.Portrait) {
      container.css("width", "auto");
      container.css("height", "100%");
    } else {
      container.css("width", "100%");
      container.css("height", "auto");
    }
    console.log("Resized", container);
  }
}

function createKeychainPhotoProduct(photoProductViewModel) {
  const className = photoProductViewModel.orientation === Orientation.Landscape ? 'image-landscape' : 'image-portrait';
  const overlayClassName = photoProductViewModel.orientation === Orientation.Landscape ? 'keychain-overlay-landscape' : 'keychain-overlay-portrait';
  const id = `photo-product-${Math.random().toString(36).substring(7)}`;
  const style = applyEffect(photoProductViewModel.effect);
  const resizeScript = getResizeFunction(id, Orientation.Portrait);
  const html = `
      <div class="keychain-mockup-container" id="${id}">
          <img class="background-photo" src="/Keychain_thumb.png" alt="Keychain"/>
          <div class="keychain-overlay ${overlayClassName}">
              <img class="${className}" style="${style}" src="${photoProductViewModel.imageUrl}" alt="Photo"/>
          </div>
      </div>
  `;
  return new PhotoProductNode(html, resizeScript);
}

function createMousePadPhotoProduct(photoProductViewModel) {
  const className = photoProductViewModel.orientation === Orientation.Landscape ? 'image-landscape' : 'image-portrait';
  const overlayClassName = photoProductViewModel.orientation === Orientation.Landscape ? 'mousepad-overlay-landscape' : 'mousepad-overlay-portrait';
  const id = `photo-product-${Math.random().toString(36).substring(7)}`;
  const style = applyEffect(photoProductViewModel.effect);
  const resizeScript = getResizeFunction(id, Orientation.Landscape);
  const html = `
      <div class="mousepad-mockup-container" id="${id}">
          <img class="background-photo" src="/Mousepad_thumb.jpeg" alt="Mouse pad"/>
          <div class="mousepad-overlay ${overlayClassName}">
              <img class="${className}" style="${style}" src="${photoProductViewModel.imageUrl}" alt="Photo"/>
          </div>
      </div>
  `;
  return new PhotoProductNode(html, resizeScript);
}

function createCardPhotoProduct(photoProductViewModel) {
  const resizeScript = () => {};
  const html = `
    <div class="card-mockup-container" style='background-image: url("/${photoProductViewModel.cardName}.png");'>
        <img class="card-overlay card-overlay-${photoProductViewModel.cardName}" style="${applyEffect(photoProductViewModel.effect)}" src="${photoProductViewModel.imageUrl}" alt="Photo"/>
    </div>
  `;
  return new PhotoProductNode(html, resizeScript);
}


function createPhotoProduct(photoProductViewModel) {
  const { imageUrl, gridType, orientation, effect, mockup, size } = photoProductViewModel;
  let sizeClass;
  switch (size){
    case Size.Small:
      sizeClass = "product-small";
      break;
    case Size.Medium:
      sizeClass = "product-medium";
      break;
    case Size.Large:
      sizeClass = "product-large";
      break;
    default:
      console.error("Unknown size", size);
      sizeClass = "product-medium";
      break;
  }
  let node = null;
  switch (mockup){
    case Mockup.Grid:
      node = createGridMockup(imageUrl, gridType, orientation, effect);
      break;
    case Mockup.Mug:
      node = createMugPhotoProduct(photoProductViewModel);
      break;
    case Mockup.Keychain:
      node = createKeychainPhotoProduct(photoProductViewModel);
      break;
    case Mockup.MousePad:
      node = createMousePadPhotoProduct(photoProductViewModel);
      break;
    case Mockup.Pillow:
      node = createPillowPhotoProduct(photoProductViewModel);
      break;
    case Mockup.Card:
      node = createCardPhotoProduct(photoProductViewModel);
      break;
    default:
      node = createGridMockup(imageUrl, gridType, orientation, effect);
      break;
  }
  node.html = `<div class="photo-product-container ${sizeClass}" photo-product>${node.html}</div>`
  return node;
}

function drawSpecialGrid9X13Plus2Times6X9(orientation, canvasId, imageUrl, effect) {
  const canvas = document.getElementById(canvasId);
  const ctx = canvas.getContext("2d");
  const gap = 30;

  // Compute canvas filter based on effect parameter.
  let canvasFilter = "none";
  if (effect === Effect.Sepia) {
    canvasFilter = "sepia(100%)";
  } else if (effect === Effect.BlackWhite) {
    canvasFilter = "grayscale(100%)";
  }

  // Container dimensions (canvas size)
  const containerWidth = canvas.width;
  const containerHeight = canvas.height;

  // Calculate dimensions for each cell:
  const colWidth = (containerWidth - gap) / 2;
  const rowHeight = (containerHeight - gap) / 2;

  // "l" cell spans two rows:
  const lX = 0;
  const lY = 0;
  const lWidth = colWidth;
  const lHeight = rowHeight * 2 + gap;

  // "s1" cell (top right)
  const s1X = colWidth + gap;
  const s1Y = 0;
  const s1Width = colWidth;
  const s1Height = rowHeight;

  // "s2" cell (bottom right)
  const s2X = colWidth + gap;
  const s2Y = rowHeight + gap;
  const s2Width = colWidth;
  const s2Height = rowHeight;

  // Create image objects for each cell
  const imgL = new Image();
  const imgS1 = new Image();
  const imgS2 = new Image();

  // Set image source from the provided URL (decoded)
  const link = decodeHtmlEntities(imageUrl);
  imgL.src = link;
  imgS1.src = link;
  imgS2.src = link;

  let imagesLoaded = 0;
  function imageLoaded() {
    imagesLoaded++;
    if (imagesLoaded === 3) {
      draw();
    }
  }
  imgL.onload = imageLoaded;
  imgS1.onload = imageLoaded;
  imgS2.onload = imageLoaded;

  function draw() {
    ctx.strokeRect(lX, lY, lWidth, lHeight);
    ctx.strokeRect(s1X, s1Y, s1Width, s1Height);
    ctx.strokeRect(s2X, s2Y, s2Width, s2Height);

    if (orientation === PhotoOrientation.Landscape) {
      ctx.save();
      ctx.translate(lX + lWidth / 2, lY + lHeight / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgL, -lHeight / 2, -lWidth / 2, lHeight, lWidth);
      ctx.restore();

      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgS1, s1X, s1Y, s1Width, s1Height);
      ctx.restore();

      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgS2, s2X, s2Y, s2Width, s2Height);
      ctx.restore();
    } else {
      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgL, lX, lY, lWidth, lHeight);
      ctx.restore();

      ctx.save();
      ctx.translate(s1X + s1Width / 2, s1Y + s1Height / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgS1, -s1Height / 2, -s1Width / 2, s1Height, s1Width);
      ctx.restore();

      ctx.save();
      ctx.translate(s2X + s2Width / 2, s2Y + s2Height / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgS2, -s2Height / 2, -s2Width / 2, s2Height, s2Width);
      ctx.restore();
    }
  }
}

function drawSpecialGrid9X13Plus4TimesMini(orientation, canvasId, imageUrl, effect) {
  const canvas = document.getElementById(canvasId);
  const ctx = canvas.getContext("2d");
  const gap = 30;

  // Container dimensions (canvas size)
  const containerWidth = canvas.width;
  const containerHeight = canvas.height;

  // --- LEFT CELL ---
  const leftX = 0;
  const leftY = 0;
  const leftWidth = (containerWidth - gap) / 2;
  const leftHeight = containerHeight;

  // --- RIGHT CELLS (corrected) ---
  const rightStartX = leftWidth + gap;
  const rightTotalWidth = (containerWidth - gap) / 2;
  // Subtract an extra gap for the vertical separation between two right columns
  const rightCellWidth = (rightTotalWidth - gap) / 2;
  const rightCellHeight = (containerHeight - gap) / 2;

  const topRight1X = rightStartX;
  const topRight1Y = 0;
  const topRight1Width = rightCellWidth;
  const topRight1Height = rightCellHeight;

  const topRight2X = rightStartX + rightCellWidth + gap;
  const topRight2Y = 0;
  const topRight2Width = rightCellWidth;
  const topRight2Height = rightCellHeight;

  const bottomRight1X = rightStartX;
  const bottomRight1Y = rightCellHeight + gap;
  const bottomRight1Width = rightCellWidth;
  const bottomRight1Height = rightCellHeight;

  const bottomRight2X = rightStartX + rightCellWidth + gap;
  const bottomRight2Y = rightCellHeight + gap;
  const bottomRight2Width = rightCellWidth;
  const bottomRight2Height = rightCellHeight;

  // Compute canvas filter based on effect parameter.
  let canvasFilter = "none";
  if (effect === Effect.Sepia) {
    canvasFilter = "sepia(100%)";
  } else if (effect === Effect.BlackWhite) {
    canvasFilter = "grayscale(100%)";
  }

  // Create image objects for each cell
  const imgLeft = new Image();
  const imgTopRight1 = new Image();
  const imgTopRight2 = new Image();
  const imgBottomRight1 = new Image();
  const imgBottomRight2 = new Image();

  const link = decodeHtmlEntities(imageUrl);
  imgLeft.src = link;
  imgTopRight1.src = link;
  imgTopRight2.src = link;
  imgBottomRight1.src = link;
  imgBottomRight2.src = link;

  let imagesLoaded = 0;
  function imageLoaded() {
    imagesLoaded++;
    if (imagesLoaded === 5) {
      draw();
    }
  }

  imgLeft.onload = imageLoaded;
  imgTopRight1.onload = imageLoaded;
  imgTopRight2.onload = imageLoaded;
  imgBottomRight1.onload = imageLoaded;
  imgBottomRight2.onload = imageLoaded;

  function draw() {
    // Draw borders for each cell
    ctx.strokeRect(leftX, leftY, leftWidth, leftHeight);
    ctx.strokeRect(topRight1X, topRight1Y, topRight1Width, topRight1Height);
    ctx.strokeRect(topRight2X, topRight2Y, topRight2Width, topRight2Height);
    ctx.strokeRect(bottomRight1X, bottomRight1Y, bottomRight1Width, bottomRight1Height);
    ctx.strokeRect(bottomRight2X, bottomRight2Y, bottomRight2Width, bottomRight2Height);

    if (orientation === PhotoOrientation.Portrait) {
      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgLeft, leftX, leftY, leftWidth, leftHeight);
      ctx.restore();

      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgTopRight1, topRight1X, topRight1Y, topRight1Width, topRight1Height);
      ctx.restore();

      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgTopRight2, topRight2X, topRight2Y, topRight2Width, topRight2Height);
      ctx.restore();

      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgBottomRight1, bottomRight1X, bottomRight1Y, bottomRight1Width, bottomRight1Height);
      ctx.restore();

      ctx.save();
      ctx.filter = canvasFilter;
      ctx.drawImage(imgBottomRight2, bottomRight2X, bottomRight2Y, bottomRight2Width, bottomRight2Height);
      ctx.restore();
    } else {
      // Draw rotated images for landscape orientation
      ctx.save();
      ctx.translate(leftX + leftWidth / 2, leftY + leftHeight / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgLeft, -leftHeight / 2, -leftWidth / 2, leftHeight, leftWidth);
      ctx.restore();

      ctx.save();
      ctx.translate(topRight1X + topRight1Width / 2, topRight1Y + topRight1Height / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgTopRight1, -topRight1Height / 2, -topRight1Width / 2, topRight1Height, topRight1Width);
      ctx.restore();

      ctx.save();
      ctx.translate(topRight2X + topRight2Width / 2, topRight2Y + topRight2Height / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgTopRight2, -topRight2Height / 2, -topRight2Width / 2, topRight2Height, topRight2Width);
      ctx.restore();

      ctx.save();
      ctx.translate(bottomRight1X + bottomRight1Width / 2, bottomRight1Y + bottomRight1Height / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgBottomRight1, -bottomRight1Height / 2, -bottomRight1Width / 2, bottomRight1Height, bottomRight1Width);
      ctx.restore();

      ctx.save();
      ctx.translate(bottomRight2X + bottomRight2Width / 2, bottomRight2Y + bottomRight2Height / 2);
      ctx.rotate(-90 * Math.PI / 180);
      ctx.filter = canvasFilter;
      ctx.drawImage(imgBottomRight2, -bottomRight2Height / 2, -bottomRight2Width / 2, bottomRight2Height, bottomRight2Width);
      ctx.restore();
    }
  }
}

function decodeHtmlEntities(str) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

const GridType = Object.freeze({
  Normal1X1: "Normal1X1",
  Normal1X2: "Normal1X2",
  Normal2X2: "Normal2X2",
  Normal4X2: "Normal4X2",
  Normal4X4: "Normal4X4",
  Special9X13Plus2Times6X9: "Special9X13Plus2Times6X9",
  Special9X13Plus4TimesMini: "Special9X13Plus4TimesMini",
});
const Effect = Object.freeze({
  Color: "Color",
  BlackWhite: "BlackWhite",
  Sepia: "Sepia",
});
const Orientation = Object.freeze({
  Portrait: "Portrait",
  Landscape: "Landscape",
});
const Mockup = Object.freeze({
  Grid: "Grid",
  Mug: "Mug",
  Pillow: "Pillow",
  Keychain: "Keychain",
  MousePad: "MousePad",
  Card: "Card",
});
const Size = Object.freeze({
  Small: "Small",
  Medium: "Medium",
  Large: "Large",
});
class PhotoProductViewModel {
  constructor(imageUrl, gridType, orientation, effect, mockup, size, cardName) {
    this.imageUrl = imageUrl;
    this.gridType = gridType;
    this.orientation = orientation;
    this.effect = effect;
    this.mockup = mockup;
    this.size = size;
    this.cardName = cardName;
  }
}

class PhotoProductNode{
  constructor(html, resizeScript) {
    this.html = html;
    this.resizeScript = resizeScript
  }
}
